export const PASSWORD_RESET_INIT = 'otp-verifying'
export const PASSWORD_RESET_ALLOW = 'allow-change-password'

export const userApi = {
  checkDt: () => ({ url: 'v2/:clientId/check-dt', method: 'get' }),
  updateDt: (data) => ({ url: 'v2/:clientId/update-dt', method: 'post', params: data }),
  getUserInfo: () => ({ url: 'v2/:clientId/self', method: 'get' }),
  updateUserInfo: (data) => ({ url: 'v2/:clientId/self', method: 'post', params: data }),
  changePassword: (data) => ({ url: 'v2/:clientId/settings/password', method: 'post', params: data }),
  setPreference: ({ defaultCategory }) => ({ url: 'v2/:clientId/settings/preference', method: 'post', params: { defaultCategory } }),
  resetOtp: ({ requestId, number }) => ({ url: 'v2/:clientId/reset', method: 'post', params: { requestId, number } }),
  getAffiliate: () => ({ url: 'v2/:clientId/affiliate', method: 'get' }),
  getAffiliateHome: () => ({ url: 'v2/:clientId/affiliate/home', method: 'get' }),
  getAffiliateDashboard: () => ({ url: 'v2/:clientId/affiliate/dashboard', method: 'get' }),
  getAffiliateDashboardList: ({ level, page, row }) => ({
    url: 'v2/:clientId/affiliate/dashboard/list',
    method: 'post',
    params: { level, page, row },
  }),
  postAffiliate: ({ affiliateCode }) => ({ url: 'v2/:clientId/affiliate', method: 'post', params: { affiliateCode } }),
  getFriends: () => ({ url: 'v2/:clientId/activities/friends', method: 'get' }),
  getFriendsHome: () => ({ url: 'v2/:clientId/activities/friends/home', method: 'get' }),
  getFriendsDashboard: () => ({ url: 'v2/:clientId/activities/friends/dashboard', method: 'get' }),
  getFriendsDashboardList: ({ level, page, row }) => ({
    url: 'v2/:clientId/activities/friends/dashboard/list',
    method: 'post',
    params: { level, page, row },
  }),
  getFriendsList: ({ type, page, row }) => ({ url: 'v2/:clientId/activities/friends/reward-list', method: 'post', params: { type, page, row } }),
  postFriends: ({ friendCode }) => ({ url: 'v2/:clientId/activities/friends', method: 'post', params: { friendCode } }),
  passwordRecovery: (recoveryData) => ({ url: 'v2/:clientId/recovery', method: 'post', params: recoveryData, isPublic: true }),
  // passwordAbandon: ({ number }) => ({ url: 'v2/:clientId/recovery/abandon', method: 'post', params: { number }, isPublic: true }), 平台版和現金網未使用
  // passwordAcknowledge: (acknowledgeData) => ({ url: 'v2/:clientId/recovery/acknowledge', method: 'post', params: acknowledgeData, isPublic: true }), 平台版和現金網未使用
  verify: () => ({ url: 'v2/:clientId/verify', method: 'post' }),
  acknowledge: ({ requestId, code }) => ({ url: 'v2/:clientId/acknowledge', method: 'post', params: { requestId, code } }),
  passwordV2RecoveryInit: ({ provider, username, countryCode, phone, email, appSecret }) => ({
    url: 'v2/:clientId/recovery/v2/initiate',
    method: 'post',
    params: { provider, username, countryCode, phone, email, appSecret },
    isPublic: true,
  }),
  passwordV2Acknowledge: ({ requestId, target, code, appSecret }) => ({
    url: 'v2/:clientId/recovery/v2/acknowledge',
    method: 'post',
    params: { requestId, target, code, appSecret },
    isPublic: true,
  }),
  // passwordV2Abandon: ({ requestId, target }) => ({ url: 'v2/:clientId/recovery/v2/abandon', method: 'post', params: { requestId, target }, isPublic: true }), 平台版和現金網未使用
  passwordV2ResetOtp: ({ requestId, target, appSecret }) => ({
    url: 'v2/:clientId/recovery/v2/reset',
    method: 'post',
    params: { requestId, target, appSecret },
    isPublic: true,
  }),
  passwordV2Change: ({ requestId, target, newPassword, appSecret }) => ({
    url: 'v2/:clientId/recovery/v2/change-password',
    method: 'post',
    params: { requestId, target, newPassword, appSecret },
    isPublic: true,
  }),
  // verifyV2Initiate: ({ strategy }) => ({
  //   // strategy: 'phone' | 'email'
  //   url: 'v2/:clientId/verify/v2/initiate',
  //   method: 'post',
  //   params: { strategy },
  // }),
  // otpAcknowledge: ({ requestId, target, code }) => ({
  //   url: 'v2/:clientId/otpsso/acknowledge',
  //   method: 'post',
  //   params: { requestId, target, code },
  //   isPublic: true,
  // }),
  // otpReset: ({ requestId, target }) => ({ url: 'v2/:clientId/otpsso/reset', method: 'post', params: { requestId, target }, isPublic: true }),
  getUserPhotoList: () => ({ url: 'v2/:clientId/get-all-avatar', method: 'get' }),
  updateUserPhoto: (data) => ({ url: 'v2/:clientId/update-user-avatar', method: 'post', params: data }),
  getUserProfile: () => ({ url: 'v2/:clientId/user-info/get-profile', method: 'get' }),
}
